const yup = require('yup');

export default class UpdateUser {
  constructor(data) {
    this.id = data && data.id ? data.id : 0;
    this.firstName = data && data.firstName ? data.firstName : '';
    this.lastName = data && data.lastName ? data.lastName : '';
    this.email = data && data.email ? data.email : '';
    this.username = data && data.username ? data.username : '';
    this.avatarPath = data && data.avatarPath ? data.avatarPath : '';
    this.tempAvatarUploadName = data && data.tempAvatarUploadName ? data.tempAvatarUploadName : '';
    this.currency = data && data.currency ? data.currency : 'USD';
    this.newPassword = data && data.newPassword ? data.newPassword : '';
    this.confirmPassword = data && data.confirmPassword ? data.confirmPassword : '';
  }
}

export const validationSchema = yup.object().shape({
  id: yup
    .number()
    .required()
    .positive(),
  firstName: yup
    .string()
    .trim()
    .required('Need your first name'),
  lastName: yup
    .string()
    .trim()
    .required('Need your last name'),
  email: yup
    .string()
    .trim()
    .email("Doesn't look like a valid email address")
    .required('Email address required for login'),
  newPassword: yup
    .string()
    .min(8, 'Must be at least 8 characters long')
    .max(256, 'Woah, not longer than 256 characters please!')
    .matches(/[\W\d]+/, 'Must contain at least one number or one special character'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Passwords must match if setting a new password'),
});



// WEBPACK FOOTER //
// ./src/models/UpdateUser.js